import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles.css'
import type { VideoGridConfig } from './types'

// Each [video_grid] shortcode renders its own mount point plus a sibling
// <script type="application/json"> holding that instance's videos/columns,
// so multiple grids (e.g. different catId values) can coexist on one page.
document.querySelectorAll<HTMLElement>('.yummy-video-grid-app').forEach(el => {
	const dataScript = document.getElementById(`${el.id}-data`)

	let config: VideoGridConfig = { videos: [], columns: 2 }
	if (dataScript?.textContent) {
		try {
			config = JSON.parse(dataScript.textContent)
		} catch (err) {
			console.error('Yummy Video Grid: could not parse config for #' + el.id, err)
		}
	}

	createApp(App, { videos: config.videos, columns: config.columns }).mount(el)
})
